import script from "./authorizationGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./authorizationGuide.vue?vue&type=script&setup=true&lang=js"

import "./authorizationGuide.vue?vue&type=style&index=0&id=33854234&lang=less"

const __exports__ = script;

export default __exports__